import { render } from "./Navbar.vue?vue&type=template&id=e19bbaa4&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=e19bbaa4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\dinho\\Documents\\GitHub\\Grajaú-E-SPORTS\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e19bbaa4"]])

export default __exports__